<template>
    <card-grid-item
        :tab-widget="{ ...tabWidget, h: 0 }"
        :card-class="['statistics-widget']"
        :min-w="12"
        :is-height-resizable="true"
        :can-drag-and-drop="false"
        :can-delete="false"
        :can-resize="false"
        :can-update="false"
        :show-header="false"
    >
        <template v-slot:card-body>
            <busy-modal :show="busy" class="chart-widget-spinner" />
            <b-row v-show="!busy" class="justify-content-left statistics-card-row">
                <b-col xl="2" lg="3" md="4" sm="6" xs="12" class="mb-3 mb-xl-0 px-2">
                    <b-media no-body class="statistics-card reservations-card px-3 py-3">
                        <b-media-body class="my-auto">
                            <h4 class="font-weight-bolder mb-0 text-white">
                                {{ reservations }}
                            </h4>
                            <b-card-text class="font-small-3 mb-0 text-white"> Reservations </b-card-text>
                        </b-media-body>
                        <b-media-aside vertical-align="center">
                            <font-awesome-icon :icon="['fas', 'user']" size="3x" :style="{ color: 'white' }" />
                        </b-media-aside>
                    </b-media>
                </b-col>
                <b-col xl="2" lg="3" md="4" sm="6" xs="12" class="mb-3 mb-xl-0 px-2">
                    <b-media no-body class="statistics-card rental-charges-card px-3 py-3">
                        <b-media-body class="my-auto">
                            <h4 class="font-weight-bolder mb-0 text-white">
                                {{ userCurrencySymbol }}{{ rentalCharges }}
                            </h4>
                            <b-card-text class="font-small-3 mb-0 text-white" style="white-space: nowrap">
                                Rental Charges
                            </b-card-text>
                        </b-media-body>
                        <b-media-aside vertical-align="center">
                            <font-awesome-icon :icon="['fas', 'money-bill-1']" size="3x" :style="{ color: 'white' }" />
                        </b-media-aside>
                    </b-media>
                </b-col>
                <b-col xl="2" lg="3" md="4" sm="6" xs="12" class="mb-3 mb-xl-0 px-2">
                    <b-media no-body class="statistics-card arrivals-card px-3 py-3">
                        <b-media-body class="my-auto">
                            <h4 class="font-weight-bolder mb-0 text-white">
                                {{ arrivals }}
                            </h4>
                            <b-card-text class="font-small-3 mb-0 text-white"> Arrivals </b-card-text>
                        </b-media-body>
                        <b-media-aside vertical-align="center">
                            <font-awesome-icon
                                :icon="['fas', 'right-to-bracket']"
                                size="3x"
                                :style="{ color: 'white' }"
                            />
                        </b-media-aside>
                    </b-media>
                </b-col>
                <b-col xl="2" lg="3" md="4" sm="6" xs="12" class="mb-3 mb-md-0 mb-lg-3 mb-xl-0 px-2">
                    <b-media no-body class="statistics-card departures-card px-3 py-3">
                        <b-media-body class="my-auto">
                            <h4 class="font-weight-bolder mb-0 text-white">
                                {{ departures }}
                            </h4>
                            <b-card-text class="font-small-3 mb-0 text-white"> Departures </b-card-text>
                        </b-media-body>
                        <b-media-aside vertical-align="center">
                            <font-awesome-icon
                                :icon="['fas', 'right-from-bracket']"
                                size="3x"
                                :style="{ color: 'white' }"
                            />
                        </b-media-aside>
                    </b-media>
                </b-col>
                <b-col xl="2" lg="3" md="4" sm="6" xs="12" class="mb-3 mb-md-0 mb-lg-3 mb-xl-0 px-2">
                    <b-media no-body class="statistics-card occupancy-card px-3 py-3">
                        <b-media-body class="my-auto">
                            <h4 class="font-weight-bolder mb-0 text-white">{{ occupancy }}%</h4>
                            <b-card-text class="font-small-3 mb-0 text-white"> Occupancy </b-card-text>
                        </b-media-body>
                        <b-media-aside vertical-align="center">
                            <font-awesome-icon :icon="['fas', 'hotel']" size="3x" :style="{ color: 'white' }" />
                        </b-media-aside>
                    </b-media>
                </b-col>
                <b-col xl="2" lg="3" md="4" sm="6" xs="12" class="mb-3 mb-md-0 mb-lg-3 mb-xl-0 px-2" v-if="displayAiScan">
                    <b-media no-body class="statistics-card ai-scan-card px-3 py-3" @click="openAiScan()">
                        <b-media-body class="my-auto">
                            <h4 class="font-weight-bolder mb-0 text-white">{{ aiScanTitle }}</h4>
                            <b-card-text class="font-small-3 mb-0 text-white">{{ aiScanSubtitle }}</b-card-text>
                        </b-media-body>
                        <b-media-aside vertical-align="center">
                            <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" size="3x" :style="{ color: 'white' }" />
                        </b-media-aside>
                    </b-media>
                </b-col>
            </b-row>
        </template>
    </card-grid-item>
</template>

<script>
    import API from '../../../../api';
    import CardGridItem from '../common/card-grid-item.vue';
    import BusyModal from '../../../generic/busy-modal/busy-modal.vue';
    import { DASHBOARD_SUMMARY_STATISTICS_ENDPOINT } from '../../../../endpoints';
    import { mapGetters } from 'vuex';
    import cardGridItemBaseMixin from '../common/card-grid-item-base-mixin';
    import Modal from '../../../generic/modal/modal.vue';

    export default {
        name: 'StatisticsCardGridItem',
        mixins: [cardGridItemBaseMixin],
        components: {
            BusyModal,
            CardGridItem,
            Modal,
        },
        mounted() {
            this.fetchSummaryStatistics();
        },
        computed: {
            ...mapGetters('header', ['userCurrencySymbol']),
        },
        data() {
            return {
                busy: true,
                reservations: 0,
                rentalCharges: 0,
                arrivals: 0,
                departures: 0,
                occupancy: 0,
                displayAiScan: false,
                aiScanTitle: 'AI Scan',
                aiScanSubtitle: 'Get Started',
            };
        },
        methods: {
            async fetchSummaryStatistics() {
                try {
                    this.busy = true;
                    const response = await API.get(
                        DASHBOARD_SUMMARY_STATISTICS_ENDPOINT()
                    );
                    this.reservations = response.data.reservations;
                    this.rentalCharges = response.data.reservations_charges.toLocaleString(
                        undefined,
                        { maximumFractionDigits: 0 }
                    );
                    this.arrivals = response.data.arrivals;
                    this.departures = response.data.departures;
                    this.occupancy = (response.data.occupancy * 100).toFixed(1);
                    this.displayAiScan = response.data.display_ai_scan;
                    this.aiScanTitle = response.data.ai_scan_title || 'AI Scan';
                    this.aiScanSubtitle = response.data.ai_scan_subtitle || 'Get Started';
                } catch {
                    this.errorToast({ text: 'Could not load summary statistics.' });
                } finally {
                    this.busy = false;
                }
            },

            async openAiScan() {
                window.location.href = '/app/ai-scan/';
            },
        },
    };
</script>

<style lang="scss">
    .vue-app-wrapper {
        .card.statistics-widget {
            min-height: 80px;
            border-color: transparent !important;
            box-shadow: none !important;
            .card-body {
                padding: 0 !important;
            }
        }
    }
    .statistics-widget {
        border: 1px solid transparent !important;
        .statistics-card-row {
            margin-left: -8px !important;
            margin-right: -8px !important;
            .statistics-card {
                border-radius: 0.428rem;
                box-shadow: 0 4px 10px 0 rgba(20, 19, 34, 0.03), 0 0 10px 0 rgba(138, 132, 224, 0.02);
                &.reservations-card {
                    background-image: -webkit-linear-gradient(45deg, #008385, #00e7eb);
                    background-image: linear-gradient(45deg, #008385, #00e7eb);
                }
                &.rental-charges-card {
                    background-image: -webkit-linear-gradient(45deg, #ff425c, #ffa8b4);
                    background-image: linear-gradient(45deg, #ff425c, #ffa8b4);
                }
                &.arrivals-card {
                    background-image: -webkit-linear-gradient(45deg, #11a578, #32eab2);
                    background-image: linear-gradient(45deg, #11a578, #32eab2);
                }
                &.departures-card {
                    background-image: -webkit-linear-gradient(45deg, #ff864a, #ffcab0);
                    background-image: linear-gradient(45deg, #ff864a, #ffcab0);
                }
                &.occupancy-card {
                    background-image: -webkit-linear-gradient(45deg, #008385, #00e7eb);
                    background-image: linear-gradient(45deg, #008385, #00e7eb);
                }
                &.ai-scan-card {
                    background-image: -webkit-linear-gradient(120deg, #1e3c72 0%, #2a5298 50%, #7fd8ff 100%);
                    background-image: linear-gradient(120deg, #1e3c72 0%, #2a5298 50%, #7fd8ff 100%);
                    transition: box-shadow 0.2s, transform 0.2s;
                    cursor: pointer;
                    &:hover {
                        box-shadow: 0 8px 24px 0 rgba(30, 60, 114, 0.18), 0 1.5px 10px 0 rgba(127, 216, 255, 0.10);
                        transform: scale(1.03);
                        z-index: 2;
                    }
                }
            }
        }
    }
</style>
